module.exports = __webpack_public_path__ + "static/media/mumla.7cb22432.mp3";